import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { WarningIconCircle } from './styles';
import CustomModal from '@/components/CustomModal/CustomModal';
import theme from '@/theme';

interface ChangeEmailProps {
  open: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

const ChangeEmailModal: FC<ChangeEmailProps> = ({ open, handleClose, onConfirm }) => {
  return (
    <CustomModal open={open} handleClose={handleClose}>
      <Stack gap="1.5rem" alignItems="center">
        <WarningIconCircle>
          <WarningAmberOutlinedIcon />
        </WarningIconCircle>
        <Typography variant="h5" fontWeight="600">
          Confirm change email
        </Typography>
        <Typography variant="body2" color={theme.palette.neutral.greyFont} maxWidth="724px">
          "You’re almost done! We are going to send you a confirmation link to your new email address. Please check your
          inbox and follow the link to complete the change. If you didn't request this change or believe it was made in
          error, please contact our support team immediately. All future communications will be sent to your new email
          address once confirmed."
        </Typography>
        <Stack flexDirection="row" gap="1.5rem" alignSelf="end">
          <Button variant="text" color="inherit" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="error" sx={{ boxShadow: 'none' }} onClick={onConfirm}>
            Send verification email
          </Button>
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default ChangeEmailModal;
